import { memo, useContext } from 'react';
import { DualSliders } from './DualSliders';
import { ADVANCED } from 'recording-review-components-lib/types/MediaTimelineTypes';
import { MediaTimelineClipHighlight } from '../components/MediaTimelineComponents/MediaTimelineClipHighlight';
import { MediaTimelineCapabilitiesContext } from '../context/MediaTimelineCapabilitiesContext';
import { jsx as _jsx } from "react/jsx-runtime";
const MediaTimelineClipEditor = /*#__PURE__*/memo(({
  variant
}) => {
  const {
    clipEditor
  } = useContext(MediaTimelineCapabilitiesContext);
  if (variant === ADVANCED && !clipEditor) {
    return /*#__PURE__*/_jsx(MediaTimelineClipHighlight, {});
  }
  if (!clipEditor) return null;
  const {
    startTime,
    endTime,
    duration,
    onStartTimeChange,
    onEndTimeChange,
    onStartHandleMouseUp,
    onEndHandleMouseUp
  } = clipEditor;
  return /*#__PURE__*/_jsx(DualSliders, {
    startValue: startTime,
    endValue: endTime,
    trackStart: 0,
    trackEnd: duration,
    step: 1,
    onStartHandleDrag: time => onStartTimeChange(time, false),
    onEndHandleDrag: time => onEndTimeChange(time, false),
    onStartHandleMouseUp: onStartHandleMouseUp,
    onEndHandleMouseUp: onEndHandleMouseUp,
    onStartTrackClick: onStartTimeChange,
    onEndTrackClick: onEndTimeChange
  });
});
export { MediaTimelineClipEditor };